var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mpx-image',{staticClass:"slogan",attrs:{"mode":"heightFix","src":(_vm.sloganIcon)}})
}
var staticRenderFns = []

export { render, staticRenderFns }